import Swal from "sweetalert2";

export function validateMaterialsBeforeSubmit(materialsContainer) {
  let invalidRows = [];

  materialsContainer.querySelectorAll(".material-row").forEach((row, idx) => {
    const unitPrice = row.querySelector(".unit-price-input")?.value;
    const supplier = row.querySelector("[name*='[supplier]']")?.value;

    if (unitPrice && unitPrice.trim() !== "" && (!supplier || supplier.trim() === "")) {
      invalidRows.push(idx + 1); // track row number for feedback
      row.querySelector("[name*='[supplier]']").classList.add("is-invalid");
    } else {
      row.querySelector("[name*='[supplier]']").classList.remove("is-invalid");
    }
  });

  if (invalidRows.length > 0) {
    Swal.fire({
      icon: "error",
      title: "Missing Supplier",
      html: `Supplier must be provided for rows with a Unit Price.<br><br>Check row(s): <b>${invalidRows.join(", ")}</b>`,
      confirmButtonText: "OK"
    });
    return false; // block submission
  }

  return true; // allow submission
}
